import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';

import { ServiceBellService } from 'app/shared/services/service-bell.service';
import { GlobalSearchService } from '@app/core/services/global-search.service';
import { FeatureToggleService } from '@app/shared/services/feature-toggle.service';

//

@Component({
  selector: 'lum-meta-menu',
  templateUrl: './meta-menu.component.html',
  styleUrls: ['./meta-menu.component.scss'],
})
export class MetaMenuComponent implements OnDestroy, OnInit {
  @HostBinding('class') _hostClass = 'lum-meta-menu';

  #showingServiceBell = false;
  public isSearchEnabled = false;

  constructor(
    private _ServiceBell :ServiceBellService,
    private globalSearchService: GlobalSearchService,
    private featureToggleService: FeatureToggleService
  ) {}

  ngOnInit() :void {
    this.isSearchEnabled = this.featureToggleService.featureEnabled('search_enable_indexing');

    this._ServiceBell.startHideOnCollapse(() => {
      this.#showingServiceBell = false;
    });
  }
  ngOnDestroy() :void {
    this._ServiceBell.stopHideOnCollapse();
  }

  handleExpertSupportClick(e :Event) {
    e.preventDefault();

    this.#toggleServiceBell();
  }

  handleSearchClick(event: Event): void {
    console.log('[MetaMenuComponent] handleSearchClick triggered');
    event.preventDefault();
    event.stopPropagation();
    this.globalSearchService.triggerSearchModalOpen();
  }

  #toggleServiceBell(targetState ?:boolean) {
    if (typeof targetState !== 'boolean') {
      targetState = !this.#showingServiceBell;
    }

    if (targetState === true) {
      this._ServiceBell.open();
    } else {
      this._ServiceBell.close();
    }

    this.#showingServiceBell = targetState;
  }
}
